import React from 'react';
import type {MessageDescriptor} from 'react-intl';
import {AccessControlIndicator, defineAccessControlledResource} from '@igp/shared/access-control';
import type {KeyValueFilter} from '@igp/shared/api';
import {DownloadCsvButton} from '@igp/shared/components/download';

import {withAccessCheck} from '@access-control';
import {adminPolicyRule} from '@policy-access';

import type {UseNegativeCarryoverDownloadProps} from '../hooks';
import {useNegativeCarryoverDownload, useNegativeCarryoverWeeklySummaryDownload} from '../hooks';
import type {NegativeCarryoverWeeklySummaryViewModelKeys} from '../types';

type NegativeCarryoverReportDownloadCsvButtonProps = UseNegativeCarryoverDownloadProps & {
    disabled?: boolean;
};

export function NegativeCarryoverReportDownloadCsvButton({disabled, ...props}: NegativeCarryoverReportDownloadCsvButtonProps) {
    const {handleDownload, isProgress} = useNegativeCarryoverDownload(props);
    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={disabled || isProgress} />;
}

type NegativeCarryoverWeeklySummaryDownloadButtonProps = {
    keys: NegativeCarryoverWeeklySummaryViewModelKeys[];
    filterString: string;
    filename: MessageDescriptor;
    disabled?: boolean;
    filter: KeyValueFilter[];
    label: MessageDescriptor;
    mode: 'client' | 'server';
};

function NegativeCarryoverWeeklySummaryDownloadButtonInner({
    disabled,
    filename,
    keys,
    filter,
    filterString,
    label,
    mode,
}: NegativeCarryoverWeeklySummaryDownloadButtonProps) {
    const {handleClick, isProgress} = useNegativeCarryoverWeeklySummaryDownload({filename, keys, filter, filterString, mode});

    return <DownloadCsvButton label={label} onClick={handleClick} loading={isProgress} disabled={isProgress || disabled} />;
}

const negativeCarryoverWeeklySummaryDownloadButtonResource = defineAccessControlledResource({
    name: 'NegativeCarryoverWeeklySummaryDownloadButton',
    rules: adminPolicyRule,
});

export const NegativeCarryoverWeeklySummaryDownloadButton = withAccessCheck(
    NegativeCarryoverWeeklySummaryDownloadButtonInner,
    negativeCarryoverWeeklySummaryDownloadButtonResource,
    AccessControlIndicator.Hidden
);
